import { cx } from '@linaria/core';
import { useRef } from 'react';
import { useMediaDomainUrl } from '@pm2/react-utils';
import { triggerEventOnContainerClick } from '@utils/common';
import { PostloadedImage } from '@utils/react';
import { image, textWrapper, heading, description, wrapper, modifiers } from './_card.style.js';
import { CardButton } from './atom.button.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Card(props) {
  const ref = useRef(null);
  const [imageSrc] = useMediaDomainUrl(props.card.image?.src, () => {
    return ref.current?.clientWidth ?? 350;
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    jsxs("div", {
      ref: ref,
      className: cx(wrapper, !props.card.image && modifiers.noImage.className),
      "data-color-variant": props.card.meta.colorVariant,
      onClick: evt => triggerEventOnContainerClick({
        ref,
        ignores: ["a", "button"],
        triggerSelector: "[data-link-trigger='true']"
      }, evt),
      children: [imageSrc && /*#__PURE__*/jsx(PostloadedImage, {
        className: image,
        src: imageSrc,
        alt: props.card.image?.alt ?? "",
        role: "presentation"
      }), /*#__PURE__*/jsxs("div", {
        className: textWrapper,
        children: [/*#__PURE__*/jsx("h4", {
          className: heading,
          children: props.card.title
        }), props.card.description?.map((desc, index) => {
          if (desc.nodeType === "text") {
            return /*#__PURE__*/jsx("p", {
              className: description,
              children: desc.value
            }, index);
          }
        })]
      }), /*#__PURE__*/jsx(CardButton, {
        title: props.card.title,
        href: props.card.link.href,
        icon: props.card.link.target,
        theme: props.card.image ? "black" : "accent"
      })]
    })
  );
}

export { Card };
//# sourceMappingURL=_card.js.map
